interface AdminLayoutProps {
  children: React.ReactNode;
  title: string;
  error?: string | null;
}

export default function AdminLayout({ children, title, error }: AdminLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">{title}</h1>
        
        {error && (
          <div className="mb-4 bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg">
            {error}
          </div>
        )}

        {children}
      </div>
    </div>
  );
}

